<template>
    <div @click="handleClick" style="background: #E8F0FF;border-radius: 2px;border: 1px solid #D9E4F8;padding:20px;cursor: pointer;">
        <div style="color: #0F1A3A;font-size: 14px;font-weight: bold;">{{ title }}</div>
        <div style="color: #0F1A3A;font-size: 12px;margin-top: 8px;opacity: 0.5;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ desc }}</div>
        <div style="display: flex;align-items: center;">
            <div style="flex: 1;font-size: 24px;color: #0F1A3A;margin-top: 32px;">{{ value }}</div>
            <div style="display: flex;align-items: center;margin-top: 32px;" v-if="type == 'default'">
                <div style="display: flex;align-items: center;margin-left: 16px;">
                    <img src="../../../assets/images/icon_fault_1.png" alt="" style="width: 20px;height: 20px;">
                    <span style="color: #0E193B;font-size: 14px;">{{ moreValue[0] }}</span>
                </div>
                <div style="display: flex;align-items: center;margin-left: 16px;">
                    <img src="../../../assets/images/icon_fault_2.png" alt="" style="width: 20px;height: 20px;">
                    <span style="color: #0E193B;font-size: 14px;">{{ moreValue[1] }}</span>
                </div>

                <div style="display: flex;align-items: center;margin-left: 16px;">
                    <img src="../../../assets/images/icon_fault_3.png" alt="" style="width: 20px;height: 20px;">
                    <span style="color: #0E193B;font-size: 14px;">{{ moreValue[2] }}</span>
                </div>
            </div>
            <div style="display: flex;align-items: center;" v-if="type == 'circle'">
                <!--一个圆环-->
                <div ref="chart_circle" style="width: 60px; height: 60px;"></div>
            </div>
        </div>
    </div>
</template>
<script>
// import * as echarts from 'echarts'
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        desc: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'default'
        },
        value: {
            type: [Number, String],
            default: ""
        },
        moreValue: {
            type: Array,
            default() { return [0, 0, 0] }
        },
        chartData: {
            type: Object,
            default() {
                return {
                    percent: 0, // 环形图百分比，可动态获取
                    total: 0 // 总数，用于计算或展示，可动态获取
                }
            }
        },
    },
    mounted() {
        this.initChart();
    },
    watch: {
        chartData: {
            handler(newVal, oldVal) {
                this.initChart();
            },
            deep: true
        }
    },
    methods: {
        handleClick(){
            this.$emit('click');
        },
        initChart() {
            if (this.type != 'circle') {
                return;
            }

            const myChart = echarts.init(this.$refs.chart_circle);
            const option = {
                grid: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['60%', '80%'], // 环形图内外半径，控制环形宽度
                        avoidLabelOverlap: false,
                        hoverAnimation: false,
                        label: {
                            show: true,
                            position: 'center',
                            formatter: `${this.chartData.percent}%` // 中心显示百分比
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: this.chartData.percent,
                                name: '长期停置占比',
                                itemStyle: {
                                    color: '#2A7AFF' // 环形图颜色，可自定义
                                }
                            },
                            {
                                value: 100 - this.chartData.percent,
                                name: '其他',
                                itemStyle: {
                                    color: '#7B99CE' // 环形图背景颜色
                                }
                            }
                        ]
                    }
                ]
            };
            myChart.setOption(option);
        },
    }

}
</script>